/**
 * PATH: packages/email-hub/src/feature/signal-strip/signalDensity.ts
 * FILE_ID: EMAILHUB-FEATURE-SIGNALSTRIP-DENSITY-001
 * PURPOSE: Pure reader-container width -> Signal Strip density contract.
 * WHY: Reader width, not browser width, determines whether controls fit.
 *      Wide 4-col is reserved for truly wide readers — split-pane triage
 *      (~700–960px) stays on medium 2×2 so FILED TO chips are not hard-clipped
 *      against lane dividers (BUG-2026-07-20-EMAIL-SIGNAL-STRIP-OVERLAP).
 */
export type SignalStripDensity = 'compact' | 'medium' | 'wide'

/** Compact → medium floor (px of the full reader container). */
export const SIGNAL_STRIP_MEDIUM_MIN = 480
/** Medium → wide floor; 840px is the four-lane contract boundary. */
export const SIGNAL_STRIP_WIDE_MIN = 840

export function densityForWidth(width: number): SignalStripDensity {
  if (width >= SIGNAL_STRIP_WIDE_MIN) return 'wide'
  if (width >= SIGNAL_STRIP_MEDIUM_MIN) return 'medium'
  return 'compact'
}
